// Generated by protoc-gen-vendasta-ts — DO NOT EDIT
/* eslint-disable */
import { defer } from 'rxjs';
import { map } from 'rxjs/operators';
import { getConfigurationRequestToJson, getConfigurationResponseFromJson, getMultiConfigurationRequestToJson, getMultiConfigurationResponseFromJson, upsertConfigurationRequestToJson, upsertConfigurationResponseFromJson, upsertProductFeatureRequestToJson, upsertProductFeatureResponseFromJson } from './codec';
import { fetchRpc } from '@vendasta/protos/fetch-transport';
import { getGlobalTransport } from '@vendasta/protos/transport';
export async function getConfiguration(request) {
    const raw = await fetchRpc('conversation.v1.InboxService/GetConfiguration', getConfigurationRequestToJson(request));
    return getConfigurationResponseFromJson(raw);
}
export function getConfiguration$(request, options) {
    return defer(() => getConfigurationWithTransport$(getGlobalTransport(), request, options));
}
export function getConfigurationWithTransport$(transport, request, options) {
    return transport
        .post('conversation.v1.InboxService/GetConfiguration', getConfigurationRequestToJson(request), options)
        .pipe(map(resp => getConfigurationResponseFromJson(resp)));
}
export async function getMultiConfiguration(request) {
    const raw = await fetchRpc('conversation.v1.InboxService/GetMultiConfiguration', getMultiConfigurationRequestToJson(request));
    return getMultiConfigurationResponseFromJson(raw);
}
export function getMultiConfiguration$(request, options) {
    return defer(() => getMultiConfigurationWithTransport$(getGlobalTransport(), request, options));
}
export function getMultiConfigurationWithTransport$(transport, request, options) {
    return transport
        .post('conversation.v1.InboxService/GetMultiConfiguration', getMultiConfigurationRequestToJson(request), options)
        .pipe(map(resp => getMultiConfigurationResponseFromJson(resp)));
}
export async function upsertConfiguration(request) {
    const raw = await fetchRpc('conversation.v1.InboxService/UpsertConfiguration', upsertConfigurationRequestToJson(request));
    return upsertConfigurationResponseFromJson(raw);
}
export function upsertConfiguration$(request, options) {
    return defer(() => upsertConfigurationWithTransport$(getGlobalTransport(), request, options));
}
export function upsertConfigurationWithTransport$(transport, request, options) {
    return transport
        .post('conversation.v1.InboxService/UpsertConfiguration', upsertConfigurationRequestToJson(request), options)
        .pipe(map(resp => upsertConfigurationResponseFromJson(resp)));
}
export async function upsertProductFeature(request) {
    const raw = await fetchRpc('conversation.v1.InboxService/UpsertProductFeature', upsertProductFeatureRequestToJson(request));
    return upsertProductFeatureResponseFromJson(raw);
}
export function upsertProductFeature$(request, options) {
    return defer(() => upsertProductFeatureWithTransport$(getGlobalTransport(), request, options));
}
export function upsertProductFeatureWithTransport$(transport, request, options) {
    return transport
        .post('conversation.v1.InboxService/UpsertProductFeature', upsertProductFeatureRequestToJson(request), options)
        .pipe(map(resp => upsertProductFeatureResponseFromJson(resp)));
}
